import React from 'react'

import MembershipsQuery from '../../core/MembershipsQuery'

import './memberships-list.scss'
import { StateProvider, getRichText } from '../../core';

const defaultData = { memberships: [] }

const Membership = ({ 
  title, 
  baseCost, 
  slug, 
  pricingMethod, 
  setCustomImage,
  thumbnailImage,
}) => {
  const onMouseEnter = () => {
    setCustomImage(thumbnailImage)
  }

  const onMouseLeave = () => {
    setCustomImage(null)
  }

  return (
    <a 
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className='_memberships-content-link' 
      href={`/memberships/${slug}`}
    >
      <h4>{title}</h4>
      <h5>From ${baseCost} Per {pricingMethod}</h5>
    </a>
  )
}

const MembershipsList = ({ 
  data = {}, 
  context = {},
  setCustomImage,
}) => {
  const { editableContent } = data

  return (
    <MembershipsQuery
      render={({ data = defaultData }) => {
        const { memberships } = data

        const membershipsToShow = (context.membershipOptions || memberships)
          .filter(m => !m.hideFromPages)
          .map(
            membership => ({
              ...membership,
              ...memberships.find(m => m.id === membership.id),
            })
          )

        return (
          <div className='_memberships-content'>
            <StateProvider value={0}>{(index, setIndex) => {
              const activeMembership = membershipsToShow[index]
              const length = membershipsToShow.length

              return (
                <div className='_memberships-content-carousel' data-only="mobile">
                  <div className='_memberships-content-image-wrapper'>
                    {membershipsToShow.map(({ id, image = {} }, i) => {
                      const url = image && image.resize && image.resize.src

                      return <div 
                        data-is-active={i === index}
                        className='_memberships-content-image' 
                        key={id} 
                        style={{ backgroundImage: `url(${url})`}} 
                      />
                    })}
                  </div>
                  <div className='_memberships-content-caption'>
                    <div className='_memberships-content-next' onClick={() => setIndex((length + index + 1) % length)} />
                    <div className='_memberships-content-prev' onClick={() => setIndex((length + index - 1) % length)} />

                    <h2>{index + 1} of {length}</h2>
                    <h2><b>Membership Options</b></h2>
  
                    <Membership {...activeMembership} />
                  </div>
                </div>
              )
            }}</StateProvider>

            <div data-only="desktop">
              <h2><b>Membership Options</b></h2>

              <div className='_memberships-content-links'>
                {membershipsToShow.map(({ id, ...rest }) => (
                  <Membership 
                    key={id} 
                    {...rest} 
                    setCustomImage={setCustomImage}
                    thumbnailImage={rest.image || { resize: { }}}
                  />
                ))}
              </div>

              {editableContent && <div className='_memberships-content-editable'>
                {getRichText(editableContent)}
              </div>}
            </div>
          </div>
        )}}
    />
  )
}

export default MembershipsList
